import { PaymentFormComponentsProps } from '@/app/components/ppra/components/ppra-payment-page/PPRAPaymentPage';
import { FormControl } from '@chakra-ui/react';
import { Box, Text } from '@cmpsr/components';
import '../../../payment-reset.css';

type CouponCodeInputProps = PaymentFormComponentsProps & {
  getPrice: () => void;
  coupon: string;
  setCoupon: (coupon: string) => void;
  couponValidationError: string | false | null;
  isSubmitting: boolean;
};

export default function CouponCodeInput({
  form,
  getPrice,
  coupon,
  setCoupon,
  couponValidationError,
  isSubmitting
}: CouponCodeInputProps) {
  const formRegistry = form.register('coupon');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCoupon(value);
    form.setValue('coupon', value);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.value) {
      getPrice();
    }
    formRegistry.onBlur(e);
  };

  return (
    <Box className="payment-reset" width="100%" display="flex" flexDirection="column" gap={0}>
      <Text
        fontSize="10px"
        fontFamily="Inter"
        fontWeight="400"
        letterSpacing="1px"
        textTransform="uppercase"
        as="label"
        htmlFor="coupon"
        color="text-primary"
        mb={0}
      >
        Promo Code
      </Text>
      <FormControl id="coupon-code" isInvalid={!!couponValidationError}>
        <input
          placeholder="Enter promo code"
          id="coupon"
          autoComplete="off"
          {...formRegistry}
          value={coupon}
          onChange={(e) => {
            handleChange(e);
            formRegistry.onChange(e);
          }}
          onBlur={handleBlur}
          disabled={isSubmitting}
          className="payment-input"
        />
        {couponValidationError && (
          <Text color="salmon-light" fontSize="xs" mt={1}>
            {couponValidationError}
          </Text>
        )}
      </FormControl>
    </Box>
  );
}